import React from 'react';

import useResourceQuery from 'dpl/shared/fetching/hooks/useResourceQuery';

import { popularCitiesResourceDefinition } from './utils/queryDefinitions';
import BreederProfileLocationLinksGroup from './BreederProfileLocationLinksGroup';

interface BreederProfilePopularCitiesProps {
  breedName: string;
  breedId: string | number;
}

export default function BreederProfilePopularCities({
  breedName,
  breedId
}: BreederProfilePopularCitiesProps) {
  const { value: citiesData, isFetching } = useResourceQuery(
    popularCitiesResourceDefinition(breedId)
  );

  return (
    <BreederProfileLocationLinksGroup
      breedName={breedName}
      linksData={citiesData}
      header={`Find ${breedName} puppies by city`}
      wideLayout
      limit={50}
      isFetching={isFetching}
    />
  );
}
